import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FooterInfos,
  FooterWrapper,
  LogoImg,
  MediaButton,
  MediaButtonsContainer,
  SecuritySection,
  SecurityBadge,
  W3CBadge,
  AccessibilityBadge,
  RadarBadge,
} from "./footer.styles";
import Logo from "assets/images/logo-prefeitura.png";
import LogoAcessibilidade from "assets/images/logo_acessibilidade.png";
import LogoRadarTransparencia from "assets/images/logo_radar_transparencia.jpg";
import { ReactComponent as Facebook } from "assets/icons/facebook.svg";
import { ReactComponent as Instagram } from "assets/icons/instagram.svg";
import { ReactComponent as Youtube } from "assets/icons/youtube.svg";
import { ReactComponent as Twitter } from "assets/icons/twitter.svg";
import { ReactComponent as LockHttps } from "assets/icons/lock-https.svg";
import { useGlobalState } from "../../../global/context/global-context";
import { formatEntityName } from "../../../../utils/entity-formatter";

export function FooterComponent() {
  const { applicationData, parametersPortal } = useGlobalState();
  const navigate = useNavigate();

  const entityDisplay = formatEntityName(applicationData?.entity?.name);
  const entityName = entityDisplay.type && entityDisplay.name
    ? `${entityDisplay.type} ${entityDisplay.name}`
    : entityDisplay.fullName || 'PREFEITURA MUNICIPAL';
  const entityDocument = applicationData?.entity?.formmatedDocument || '';
  const entityAddress = applicationData?.entity?.address;

  const fullAddress = entityAddress
    ? `${entityAddress.street}, Nº ${entityAddress.number}, ${entityAddress.neighborhood}, ${entityAddress.city}-${entityAddress.state}. CEP: ${entityAddress.formattedZipCode}`
    : '';

  const operatingHours = applicationData?.entity?.operatingHours || 'Segunda a Sexta: 8h às 17h';

  const isSecure = window.location.protocol === 'https:' || window.location.hostname === 'localhost';
  const isLocalhost = window.location.hostname === 'localhost';

  // Verifica se deve mostrar os ícones de redes sociais
  const showSocialMedia = isLocalhost ||
    parametersPortal?.urlProfileFacebook ||
    parametersPortal?.urlProfileTwitter ||
    parametersPortal?.urlProfileInstagram ||
    parametersPortal?.urlProfileYoutube;

  // URLs das redes sociais (usa # como fallback para localhost)
  const facebookUrl = parametersPortal?.urlProfileFacebook || '#';
  const twitterUrl = parametersPortal?.urlProfileTwitter || '#';
  const instagramUrl = parametersPortal?.urlProfileInstagram || '#';
  const youtubeUrl = parametersPortal?.urlProfileYoutube || '#';

  const handleTermsClick = () => {
    navigate('/termos-de-uso');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePrivacyClick = () => {
    navigate('/politica-de-privacidade');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleAccessibilityClick = () => {
    navigate('/acessibilidade');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer>
      <FooterWrapper>
        <div>
          <LogoImg
            alt={entityName}
            src={
              applicationData?.entity?.brandLogo
                ? `data:image/png;base64,${applicationData?.entity?.brandLogo}`
                : applicationData?.entity?.stateBrandLogo || Logo
            }
          />
          <span>
            <b>{entityName}</b>
            <br /> {fullAddress || 'Endereço não disponível'}
            {entityDocument && (
              <>
                <br />
                CNPJ: {entityDocument}
              </>
            )}
            <br />
            Horário de Funcionamento: {operatingHours}
          </span>
        </div>
        {showSocialMedia && (
          <MediaButtonsContainer>
            {(facebookUrl !== '#' || isLocalhost) && (
              <MediaButton
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook />
              </MediaButton>
            )}
            {(twitterUrl !== '#' || isLocalhost) && (
              <MediaButton
                href={twitterUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter />
              </MediaButton>
            )}
            {(instagramUrl !== '#' || isLocalhost) && (
              <MediaButton
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram />
              </MediaButton>
            )}
            {(youtubeUrl !== '#' || isLocalhost) && (
              <MediaButton
                href={youtubeUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube />
              </MediaButton>
            )}
          </MediaButtonsContainer>
        )}
      </FooterWrapper>
      <FooterInfos>
        <span>
          Copyright ©{new Date().getFullYear()}, {entityName} | Todos os direitos
          reservados
        </span>
        <div>
          <button onClick={handleTermsClick}>TERMOS DE USO</button>
          <button onClick={handlePrivacyClick}>POLÍTICA DE PRIVACIDADE</button>
        </div>
      </FooterInfos>
      <SecuritySection>
        {isSecure && (
          <SecurityBadge>
            <LockHttps />
            <span>Site Seguro - HTTPS</span>
          </SecurityBadge>
        )}
        <W3CBadge
          href="https://validator.w3.org/nu/?doc=https%3A%2F%2Fwww.w3.org%2F"
          target="_blank"
          rel="noopener noreferrer"
          title="Validar HTML com W3C"
        >
          <img
            src="https://www.w3.org/Icons/valid-html401"
            alt="Valid HTML"
          />
        </W3CBadge>
        <AccessibilityBadge
          onClick={(e) => {
            e.preventDefault();
            handleAccessibilityClick();
          }}
          title="Acessibilidade - Compromisso com a Inclusão Digital"
        >
          <img
            src={LogoAcessibilidade}
            alt="Acessibilidade"
          />
        </AccessibilityBadge>
        <RadarBadge
          href="https://radardatransparencia.atricon.org.br/"
          target="_blank"
          rel="noopener noreferrer"
          title="Radar da Transparência Pública - ATRICON"
        >
          <img
            src={LogoRadarTransparencia}
            alt="Radar da Transparência"
          />
        </RadarBadge>
      </SecuritySection>
    </footer>
  );
}
